import { useAuthedFetch } from '../../../auth/useAuthedFetch'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

export const FILE_TYPES_MAP = {
  pdf: 'pdf',
  xls: 'xls',
}

const MIME_TYPES_MAP = {
  [FILE_TYPES_MAP.pdf]: 'data:application/pdf',
  [FILE_TYPES_MAP.xls]:
    'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

const useDownloadFile = () => {
  const authedFetch = useAuthedFetch()

  return (fileId, fileType) => {
    if (!Object.keys(MIME_TYPES_MAP).includes(fileType))
      throw new Error('File type not supported')

    const endpoint =
      fileType === FILE_TYPES_MAP.pdf
        ? 'rpc-client-doc-pdf-for'
        : 'rpc-client-doc-xls-for'

    return authedFetch('POST', `${BACKEND_ENDPOINT}/${endpoint}`, {
      data: {
        uid: fileId,
      },
      parseJSON: true,
    })
      .then(response => {
        const fileDetails = response.data.data
        const fileUrl = `${MIME_TYPES_MAP[fileType]};base64,${fileDetails.file_content}`
        const downloadLink = document.createElement('a')
        const fileName = fileDetails.file_name
        downloadLink.href = fileUrl
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(error => {
        throw error
      })
  }
}

export default useDownloadFile
